import React, { useState, useRef } from 'react';
import { useIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import AliceCarousel from 'react-alice-carousel';
import { FormattedMessage } from '../../util/reactIntl';
import { LandscapeCard, IconCarouselArrows, NamedLink, IconSearch } from '../../components';


import css from './LandscapesCarousel.module.css';
import { useConfiguration } from '../../context/configurationContext';

const MODAL_BREAKPOINT = 768;

const LandscapesCarousel = props => {

  const {
    landscapes,
    theme = "dark"
  } = props;

  if (!landscapes?.length) return null;

  const isDarkTheme = theme === "dark";
  const isLightTheme = theme === "light";

  const [realIndex, setRealIndex] = useState(0);
  const [internalIndex, setInternalIndex] = useState(0);

  const config = useConfiguration();
  const intl = useIntl();

  const isWindowDefined = typeof window !== 'undefined';
  const isMobileLayout = isWindowDefined && window.innerWidth < MODAL_BREAKPOINT;

  const carouselItems = landscapes.map(l => (

    <div className={css.landscapeCardHolder} key={l.blockId}>
      <LandscapeCard
        className={css.landscapeCard}
        key={l.blockId}
        landscape={l}
      />
    </div>
  ));

  const prevButton = () => (
    <button className={css.prevButton} type="button">
      <IconCarouselArrows type={isLightTheme ? "transparent-left" : "black-left"} />
    </button>
  );

  const nextButton = () => (
    <button className={css.nextButton} type="button">
      <IconCarouselArrows type={isLightTheme ? "transparent-right" : "black-right"} />
    </button>
  );


  const itemsCount = carouselItems.length;
  const showFullCarousel = itemsCount > 4;
  const itemsToShow = 4;

  const carouselRef = useRef(null);

  const goTo = (targetReal) => {
    if (!carouselRef.current) return;
    const currentInternal = internalIndex;
    const currentReal = realIndex;
    const deltaForward = (targetReal - currentReal + itemsCount) % itemsCount;
    const deltaBackward = (currentReal - targetReal + itemsCount) % itemsCount;
    const moveBy = deltaForward <= deltaBackward ? deltaForward : -deltaBackward;
    const newInternal = currentInternal + moveBy;

    carouselRef.current?.slideTo(newInternal);
  };

  return (
    <div className={classNames(css.root)}>
      <div className={css.landscapesCarouselHolder}>
        <AliceCarousel
          className={css.landscapesCarousel}
          ref={carouselRef}
          items={carouselItems}
          infinite={true}
          slideBy={1}
          autoPlay
          autoPlayInterval={2000}
          disableDotsControls
          onSlideChanged={({ item }) => {
            setInternalIndex(item);
            setRealIndex(((item % itemsCount) + itemsCount) % itemsCount);
          }}
          renderPrevButton={prevButton}
          renderNextButton={nextButton}
          responsive={{
            0: { items: 1 },
            768: { items: Math.min(itemsCount, 2), itemsFit: 'contain' },
            860: {
              items: Math.min(itemsCount, 2),
              itemsFit: 'contain',
            },
          }}
        />
        <div className={classNames(css.customDots, isLightTheme && css.customDotsLight)}>
          {carouselItems.map((_, i) => (
            <button
              key={i}
              className={classNames(css.dot, { [css.dotActive]: i === realIndex })}
              onClick={() => goTo(i)}
            />
          ))}
        </div>
      </div>

      <div className={css.showAllLandscapesHolder}>
        <NamedLink
          className={classNames(css.showAllLandscapes, isLightTheme && css.showAllLandscapesLight)}
          name="CMSPage"
          params={{ pageId: "landscapes" }}
        >
          <IconSearch />
          <FormattedMessage id="LandscapeCard.showAll" />
        </NamedLink>
      </div>
    </div>
  );
};

export default LandscapesCarousel;


